import React, { useState } from 'react'
import Ikona from './IkonaZlecenia'
import KartaWykonawcy, { ZrodloOcenGoogle } from './KartaWykonawcy'
import { najnizszaCena } from '../../lib/wykonawcy'
import { zl } from '../../lib/rynek'
import './Zlecenie.css'

/**
 * Lista najlepiej dopasowanych wykonawców u klienta (makieta „VoltValue dla domu” 12, D8 i D14). Górę karty (logo,
 * certyfikat, ocena Google, zdjęcia, specjalizacje) rysuje `KartaWykonawcy` z pakietu P2, tu dochodzą powody
 * dopasowania, fakty, oferta i wybór. Najniższa cena na niebiesko, znacznik „w budżecie” albo „o X ponad budżet”. Bez rankingu: kolejność
 * przychodzi z backendu (losowa, stała dla zlecenia).
 *
 * Wybór klikiem w kartę albo w pole wyboru; „Przekaż kontakt wybranym” prosi o potwierdzenie, bo przekazania nie da
 * się cofnąć (kontakt cofa się potem przy każdym wykonawcy: „Nie kontaktujcie się już ze mną”).
 *
 * `onPrzekaz(ids)`: prawdziwa lista. `przyklad`: wszystko dzieje się na stronie, a `onPrzekazPrzyklad` pozwala
 * stronie zamiast tego pokazać zachętę do konta (gość).
 */

/** „w budżecie” albo „o X ponad budżet”: flaga z backendu (`oferta.w_budzecie`), a bez niej liczona z zakresu. */
const ZnacznikBudzetu = ({ k, zakresDo }) => {
  const ponad = k.wBudzecie === false || (k.wBudzecie == null && zakresDo != null && k.cena > zakresDo)
  if (k.wBudzecie == null && zakresDo == null) return null
  if (!ponad) return <span className="znacznik ok">w budżecie</span>
  return <span className="znacznik ponad">{zakresDo != null && k.cena > zakresDo ? `o ${zl(k.cena - zakresDo)} ponad budżet` : 'ponad budżet'}</span>
}

const KartaNaLiscie = ({ k, najtansza, zakresDo, wybor, zaznaczona, onZaznacz, poPrzekazaniu, busy, onKoniec }) => {
  const [pytam, setPytam] = useState(false)
  const dalej = poPrzekazaniu && k.kontakt
  const odpada = poPrzekazaniu && !k.kontakt
  const klik = (e) => {
    if (!wybor || e.target.closest('a, button, label, input')) return
    onZaznacz()
  }
  // Profil w kształcie z pakietu P2 (`profil_wykonawcy`): ta sama karta co w ankiecie firmy.
  const profil = {
    logo_url: k.logo, zdjecia: k.zdjecia, liczba_zdjec: k.zdjecia.length + k.wiecej, google: k.google,
    specjalizacje: k.specjalizacje, certyfikat: k.certyfikat,
  }

  return (
    // Klik w kartę to skrót myszy; klawiatura ma pole wyboru w rogu karty.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <li className={`firma-wpis${wybor ? ' do-wyboru' : ''}${odpada ? ' odpada' : ''}`} onClick={klik}>
      <KartaWykonawcy nazwa={k.nazwa} miasto={k.miasto} odleglosc={k.odleglosc} profil={profil}
                      className={zaznaczona ? '!border-blue-600 shadow-[0_0_0_3px_rgba(37,99,235,0.18)]' : dalej ? '!border-emerald-500' : ''}
                      obokNazwy={wybor && (
                        <label className="wybor" title="Wybieram">
                          <input type="checkbox" checked={zaznaczona} onChange={onZaznacz} />
                          <span className="sr-only">Wybieram: {k.nazwa}</span>
                        </label>
                      )}>
        {k.powody.length > 0 && <p className="powod"><b>Dlaczego ten wykonawca:</b> {k.powody.join(' · ')}</p>}

        {k.fakty.length > 0 && (
          <span className="fakty-firmy">
            {k.fakty.map((f) => <span key={f} className="fakt">{f}</span>)}
          </span>
        )}

      {k.maOferte ? (
        <div className="oferta-firmy">
          <span>Cena brutto
            {k.cena != null
              ? <b className={k.cena === najtansza ? 'najtansza' : undefined} title={k.cena === najtansza ? 'Najniższa cena wśród ofert' : undefined}>{zl(k.cena)}</b>
              : <b>do ustalenia</b>}
            {k.cena != null && <ZnacznikBudzetu k={k} zakresDo={zakresDo} />}
          </span>
          <span>Montaż<b>{k.termin || 'do ustalenia'}</b></span>
          <span>Gwarancja<b>{k.gwarancja || 'do ustalenia'}</b></span>
        </div>
      ) : (
        <p className="firma-wynik nie">Przygotowuje ofertę</p>
      )}
      {k.wiadomosc && <p className="oferta-wiadomosc">{k.wiadomosc}</p>}
      {k.zamienniki?.length > 0 && (
        <ul className="zamienniki">
          {k.zamienniki.map((z, i) => (
            <li key={i}><b>Zamiast {z.zamiennik_za}:</b> {z.model}{z.ilosc > 1 ? ` (${z.ilosc} szt.)` : ''}{z.zamiennik_powod ? `, powód: ${z.zamiennik_powod}` : ''}</li>
          ))}
        </ul>
      )}

      {dalej && (
        <div className="firma-wynik ok">
          <span><Ikona nazwa="ok" rozmiar={15} grubosc={2.8} />Ma Twój kontakt</span>
          {k.koniec ? (
            <span style={{ color: 'var(--fg-3)' }}>Prośba o koniec kontaktu wysłana</span>
          ) : pytam ? (
            <span className="koniec-pytanie">
              Wykonawca nie będzie się już kontaktować. Na pewno?
              <button type="button" className="btn btn-obrys btn-m" style={{ height: 34 }} disabled={busy}
                      onClick={() => { onKoniec(k.id); setPytam(false) }}>Tak</button>
              <button type="button" className="koniec-btn" onClick={() => setPytam(false)}>Anuluj</button>
            </span>
          ) : (
            <button type="button" className="koniec-btn" onClick={() => setPytam(true)}>Nie kontaktujcie się już ze mną</button>
          )}
        </div>
      )}
      {odpada && <p className="firma-wynik nie">Dostał informację, że nie przeszedł dalej</p>}
      </KartaWykonawcy>
    </li>
  )
}

const ListaWykonawcow = ({
  karty, zakresDo = null, wybor = true, poPrzekazaniu = false, busy = false, onPrzekaz, onKoniec, przyklad = false,
  onPrzekazPrzyklad,
}) => {
  const [zaznaczone, setZaznaczone] = useState([])
  const [pytam, setPytam] = useState(false)
  const [przekazanePrzyklad, setPrzekazanePrzyklad] = useState(false)
  const [koniecPrzyklad, setKoniecPrzyklad] = useState([])
  const po = poPrzekazaniu || przekazanePrzyklad
  const najtansza = najnizszaCena(karty)
  const przelacz = (id) => setZaznaczone((z) => (z.includes(id) ? z.filter((x) => x !== id) : [...z, id]))
  const widoczne = przyklad
    ? karty.map((k) => ({ ...k, kontakt: przekazanePrzyklad && zaznaczone.includes(k.id), koniec: koniecPrzyklad.includes(k.id) }))
    : karty
  const n = zaznaczone.length

  const przekaz = () => {
    if (przyklad) {
      if (onPrzekazPrzyklad?.() === false) return
      setPrzekazanePrzyklad((p) => !p)
      setKoniecPrzyklad([])
      return
    }
    setPytam(true)
  }

  return (
    <>
      <ul className="firmy">
        {widoczne.map((k) => (
          <KartaNaLiscie key={k.id} k={k} najtansza={najtansza} zakresDo={zakresDo} busy={busy}
                          wybor={wybor && !po} zaznaczona={!po && zaznaczone.includes(k.id)} onZaznacz={() => przelacz(k.id)}
                          poPrzekazaniu={po}
                          onKoniec={przyklad ? (id) => setKoniecPrzyklad((x) => [...x, id]) : onKoniec} />
        ))}
      </ul>
      {karty.some((k) => k.google) && <ZrodloOcenGoogle className="google-zrodlo" />}
      {(wybor || przekazanePrzyklad) && (
        <div className="lista-stopka">
          {pytam ? (
            <>
              <p className="form-uwaga" style={{ textAlign: 'left', color: 'var(--fg-2)', fontSize: 14 }}>
                Wybrani wykonawcy ({n}) dostaną Twój adres, imię, e-mail i telefon. Pozostali dostaną informację, że nie
                przeszli dalej. Wyboru nie da się cofnąć, ale przy każdym wykonawcy możesz potem kliknąć „Nie kontaktujcie
                się już ze mną”.
              </p>
              <button type="button" className="btn btn-glowny btn-l" disabled={busy} onClick={() => onPrzekaz(zaznaczone)}>
                {busy ? 'Przekazuję…' : 'Tak, przekaż kontakt'}
              </button>
              <button type="button" className="link" style={{ alignSelf: 'center' }} onClick={() => setPytam(false)}>Wróć do listy</button>
            </>
          ) : (
            <>
              <button type="button" className="btn btn-glowny btn-l" disabled={!n && !po} onClick={przekaz}>
                {po ? 'Zmień wybór' : n ? `Przekaż kontakt wybranym (${n})` : 'Przekaż kontakt wybranym'}
              </button>
              <p className="form-uwaga" aria-live="polite">
                {po
                  ? 'Wybrani wykonawcy mają Twój kontakt. Pozostali dostali informację, że nie przeszli dalej.'
                  : 'Zaznacz jednego albo kilku wykonawców. Pozostali dostaną informację, że nie przeszli dalej.'}
              </p>
            </>
          )}
        </div>
      )}
    </>
  )
}

export default ListaWykonawcow
